import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { formatPhone } from "../../../utils/formatPhone";
import { updatePersonalInformation, updateEmail } from "../../../services/settingsService";
import { updateBusinessProfileInSlice } from "../../../store/businessProfileByIdSlice";
import { patchProfile } from "../../../store/profileSlice";
import { toast } from "react-toastify";

const PersonalInformation = ({ profile }) => {
    const dispatch = useDispatch();

    const [displayField, setDisplayField] = useState(null);
    const [numberField, setNumberField] = useState(null);
    const [emailField, setEmailField] = useState(null);
    const [emailError, setEmailError] = useState("");
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [firstName, setFirstName] = useState(
        profile?.profile?.role === "freelancer"
            ? profile?.profile?.first_name || ""
            : ""
    );

    const [lastName, setLastName] = useState(
        profile?.profile?.role === "freelancer"
            ? profile?.profile?.last_name || ""
            : ""
    );

    const [businessName, setBusinessName] = useState(
        profile?.profile?.role === "business"
            ? profile?.business_profile?.business_name || ""
            : ""
    );

    const [email, setEmail] = useState(
        profile?.profile?.email || ""
    );

    const [displayName, setDisplayName] = useState(
        profile?.profile?.first_name || ""
    );

    const [phoneNumber, setPhoneNumber] = useState(
        profile?.profile?.phone_number || ""
    );

    const handleSave = async (field) => {
        try {
            if (field === "email") {
                const originalEmail = profile?.profile?.email || "";
                setEmailError("");
                setPasswordError("");
                if (email === originalEmail) {
                    setEmailField(null);
                    setPassword("");
                    return;
                }

                try {
                    setEmailError("");

                    const updatedEmail = await updateEmail({
                        email,
                        password,
                    });

                    dispatch(
                        patchProfile({
                            profile: {
                                ...profile.profile,
                                email: updatedEmail.email,
                            },
                        })
                    );

                    toast.success("Email updated successfully.");
                    setPassword("");
                    setPasswordError("");
                    setEmailError("");
                    setEmailField(null);

                } catch (error) {
                    if (error.response?.data?.email) {
                        setEmailError(error.response.data.email[0]);
                    }

                    if (error.response?.data?.password) {
                        setPasswordError(error.response.data.password[0]);
                    }

                    if (
                        error.response?.data?.email ||
                        error.response?.data?.password
                    ) {
                        return;
                    }

                    throw error;
                }
            }

            if (field === "displayName") {

                if (profile?.profile?.role === "freelancer") {

                    const originalFirstName = profile?.profile?.first_name || "";
                    const originalLastName = profile?.profile?.last_name || "";

                    if (
                        firstName === originalFirstName &&
                        lastName === originalLastName
                    ) {
                        setDisplayField(null);
                        return;
                    }

                    const updatedProfile = await updatePersonalInformation({
                        first_name: firstName,
                        last_name: lastName,
                    });

                    dispatch(
                        patchProfile({
                            profile: {
                                ...profile.profile,
                                ...updatedProfile,
                            },
                        })
                    );

                    toast.success("Name updated successfully.");
                    setDisplayField(null);

                } else if (profile?.profile?.role === "business") {

                    const originalBusinessName =
                        profile?.business_profile?.business_name || "";

                    if (businessName === originalBusinessName) {
                        setDisplayField(null);
                        return;
                    }

                    const updatedProfile = await updatePersonalInformation({
                        business_name: businessName,
                    });

                    dispatch(
                        patchProfile({
                            business_profile: {
                                ...profile.business_profile,
                                business_name: businessName,
                            },
                        })
                    );

                    dispatch(
                        updateBusinessProfileInSlice({
                            business_name: businessName,
                        })
                    );

                    toast.success("Business name updated successfully.");
                    setDisplayField(null);

                } else {

                    const originalName = profile?.profile?.first_name || "";

                    if (displayName === originalName) {
                        setDisplayField(null);
                        return;
                    }

                    const updatedProfile = await updatePersonalInformation({
                        first_name: displayName,
                    });

                    dispatch(
                        patchProfile({
                            profile: {
                                ...profile.profile,
                                ...updatedProfile,
                            },
                        })
                    );

                    toast.success("Display name updated successfully.");
                    setDisplayField(null);

                }
            }

            if (field === "phoneNumber") {
                const originalPhone = profile?.profile?.phone_number || "";

                if (phoneNumber === originalPhone) {
                    setNumberField(null);
                    return;
                }

                const updatedProfile = await updatePersonalInformation({
                    phone_number: phoneNumber,
                });

                dispatch(
                    patchProfile({
                        profile: {
                            ...profile.profile,
                            ...updatedProfile,
                        },
                    })
                );

                toast.success("Phone number updated successfully.");
                setNumberField(null);
            }

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong. Please try again.");
        }
    };

    return (
        <div className="settings-list">

            <div className="settings-edit-item">
                <p>Email</p>

                <div className="settings-right">

                    {emailField === "email" ? (
                        <div className="settings-edit">

                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    setEmailError("");
                                }}
                            />

                            {emailError && (
                                <small className="settings-error error-color">
                                    {emailError}
                                </small>
                            )}

                            <input
                                type="password"
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setPasswordError("");
                                }}
                            />

                            {passwordError && (
                                <small className="settings-error error-color">
                                    {passwordError}
                                </small>
                            )}

                            <div className="settings-edit-actions">
                                <button
                                    className="save-button"
                                    onClick={() => handleSave("email")}
                                >
                                    Save
                                </button>

                                <button
                                    className="cancel-button"
                                    onClick={() => {
                                        setEmail(profile?.profile?.email || "");
                                        setPassword("");
                                        setEmailError("");
                                        setPasswordError("");
                                        setEmailField(null);
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    ) : (
                        <>
                            <small>{profile?.profile?.email || "Not set"}</small>

                            <i
                                className="fas fa-pen"
                                onClick={() => setEmailField("email")}
                                style={{ cursor: "pointer" }}
                            />
                        </>
                    )}

                </div>
            </div>

            <div className="settings-edit-item">
                <p className="settings-display-name">
                    {profile?.profile?.role === "freelancer"
                        ? "Name"
                        : profile?.profile?.role === "business"
                            ? "Business Name"
                            : "Display Name"}
                </p>

                <div className="settings-right">

                    {displayField === "displayName" ? (
                        <div className="settings-edit">

                            {profile?.profile?.role === "freelancer" ? (
                                <>
                                    <input
                                        type="text"
                                        placeholder="First Name"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />

                                    <input
                                        type="text"
                                        placeholder="Last Name"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </>
                            ) : profile?.profile?.role === "business" ? (
                                <input
                                    type="text"
                                    placeholder="Business Name"
                                    value={businessName}
                                    onChange={(e) => setBusinessName(e.target.value)}
                                />
                            ) : (
                                <input
                                    type="text"
                                    placeholder="Display Name"
                                    value={displayName}
                                    onChange={(e) => setDisplayName(e.target.value)}
                                />
                            )}

                            <div className="settings-edit-actions">
                                <button
                                    className="save-button"
                                    onClick={() => handleSave("displayName")}
                                >
                                    Save
                                </button>

                                <button
                                    className="cancel-button"
                                    onClick={() => {
                                        if (profile?.profile?.role === "freelancer") {
                                            setFirstName(profile?.profile?.first_name || "");
                                            setLastName(profile?.profile?.last_name || "");
                                        } else if (profile?.profile?.role === "business") {
                                            setDisplayName(profile?.business_profile?.business_name || "");
                                        } else {
                                            setDisplayName(
                                                profile?.profile?.first_name ||
                                                profile?.profile?.username ||
                                                ""
                                            );
                                        }

                                        setDisplayField(null);
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    ) : (
                        <>
                            <small>
                                {profile?.profile?.role === "freelancer"
                                    ? `${profile?.profile?.first_name || ""} ${profile?.profile?.last_name || ""}`.trim()
                                    : profile?.profile?.role === "business"
                                        ? profile?.business_profile?.business_name
                                        : profile?.profile?.first_name || profile?.profile?.username}
                            </small>

                            <i
                                className="fas fa-pen"
                                onClick={() => setDisplayField("displayName")}
                                style={{ cursor: "pointer" }}
                            />
                        </>
                    )}

                </div>
            </div>

            {/* PHONE NUMBER */}
            <div className="settings-edit-item">

                <p className="settings-display-phone">Phone Number</p>

                <div className="settings-right">

                    {numberField === "phoneNumber" ? (
                        <div className="settings-edit">
                            <input
                                value={phoneNumber}
                                onChange={(e) =>
                                    setPhoneNumber(e.target.value)
                                }
                            />

                            <div className="settings-edit-actions">
                                <button
                                    className="save-button"
                                    onClick={() => handleSave("phoneNumber")}
                                >
                                    Save
                                </button>

                                <button
                                    className="cancel-button"
                                    onClick={() => {
                                        setPhoneNumber(profile?.profile?.phone_number || "");
                                        setNumberField(null);
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    ) : (
                        <>
                            <small>
                                {formatPhone(
                                    profile?.profile?.phone_number
                                ) || "Not set"}
                            </small>

                            <i
                                className="fas fa-pen"
                                onClick={() => setNumberField("phoneNumber")}
                                style={{ cursor: "pointer" }}
                            />
                        </>
                    )}

                </div>

            </div>

        </div>
    );
};

export default PersonalInformation;